<div
  class="navbar navbar-expand-sm navbar-light bg-white sticky-top navbar-ideation">
  <div class="container">
    <div class="navbar-header d-flex align-items-center">
      <img
        class="navbar-logo"
        alt="WeDaVinci"
        src="/assets/images/logo-green.png" />
      <a routerLink="/" class="navbar-brand d-flex">
        <strong>We</strong>
        <span>DaVinci</span>
      </a>
    </div>

    <ul class="navbar-nav ms-auto">
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" routerLink="/signup">Sign up</a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" routerLink="/login">Login</a>
      </li>
    </ul>
  </div>
</div>

<main>
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
